/******************
 * Duplicate Ad
 * BEGIN
******************/
if( document.querySelector(".duplicate-ad-btn") ) {
    const duplicateAdBtn = document.querySelector(".duplicate-ad-btn");
    const confirmDuplicate = document.querySelector('.custom-message-modal-btn.confirm');
    const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');
    const modal = document.querySelector('.custom-message-modal-overlay');

    if (modal) {
        modal.addEventListener('click', function(e) { 
            if (e.target.classList.contains('removed')) {
                modal.classList.remove('d-flex');
                e.target.remove();
            }
        });
    }

    duplicateAdBtn.addEventListener('click', function() {
        const duplicatePost = duplicateAdBtn.getAttribute("data-job");

        confirmDuplicate.style.display = 'block';
        confirmBtnCancel.style.display = 'block';

        confirmDuplicate.setAttribute('data-job', duplicatePost);
        confirmDuplicate.setAttribute('data-action', 'duplicate');

        const modalMessage = document.querySelector('.custom-message-modal-body p');
        if (modalMessage) {
            modalMessage.textContent = 'Are you sure you want to duplicate this Ad ?';
        }

        const modalTriggerBtn = document.querySelector('.open-modal-btn');
        if (modalTriggerBtn) {
            modalTriggerBtn.click();
        }
    });

    confirmDuplicate.addEventListener('click', function() {
        const duplicatePost = this.getAttribute('data-job');
        const actionPost = this.getAttribute('data-action');
        if( actionPost != 'duplicate' ) {
            return;
        }

        const modalBody = document.querySelector('.custom-message-modal-body p');
        if (modalBody) {
            modalBody.textContent = 'Duplicating Ad. Please wait...';
            confirmDuplicate.style.display = 'none';
            confirmBtnCancel.style.display = 'none';

            fetch(ajax_callback_data.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'yakkly_employer_job_detail_action',
                    jobId: duplicatePost,
                    job_action: actionPost,
                    nonce: ajax_callback_data.ajax_nonce
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.success) {
                    window.location.href = data.data.redirect_url;
                    return;
                    
                } else {
                    modalBody.textContent = 'Failed to duplicate Ad.';
                    console.error('Failed to duplicate Ad.');
                }
            })
            .catch(err => {
                modalBody.textContent = 'An error occurred.';
                console.error(err);
            });
        }

    });
}
/******************
 * Duplicate Ad
 * END
******************/

/*****************
 * Remove Ad
 * BEGIN
*****************/
if( document.querySelector(".remove-ad-btn") ) {
    const removeAdBtn = document.querySelector(".remove-ad-btn");
    const confirmRemoveAd = document.querySelector('.custom-message-modal-btn.confirm');
    const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');
    const modal = document.querySelector('.custom-message-modal-overlay');

    if (modal) {
        modal.addEventListener('click', function(e) { 
            if (e.target.classList.contains('removed')) {
                modal.classList.remove('d-flex');
                e.target.remove();
            }
        });
    }

    removeAdBtn.addEventListener('click', function() {
        const employerJob = removeAdBtn.getAttribute("data-job");

        confirmRemoveAd.style.display = 'block';
        confirmBtnCancel.style.display = 'block';

        confirmRemoveAd.setAttribute('data-job', employerJob);
        confirmRemoveAd.setAttribute('data-action', 'remove');

        const modalMessage = document.querySelector('.custom-message-modal-body p');
        if (modalMessage) {
            modalMessage.textContent = 'Are you sure you want to remove this Ad ?';
        }

        const modalTriggerBtn = document.querySelector('.open-modal-btn');
        if (modalTriggerBtn) {
            modalTriggerBtn.click();
        }

    });

    confirmRemoveAd.addEventListener('click', function() {
        const employerJob = this.getAttribute('data-job');
        const actionPost = this.getAttribute('data-action');
        
        if (actionPost !== 'remove') {
            return;
        }
    
        const modalBody = document.querySelector('.custom-message-modal-body p');
    
        if (modalBody) {
            modalBody.textContent = 'Removing Ad. Please wait...';
            confirmRemoveAd.style.display = 'none';
            confirmBtnCancel.style.display = 'none';
    
            fetch(ajax_callback_data.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'yakkly_employer_job_detail_action',
                    jobId: employerJob,
                    job_action: actionPost,
                    nonce: ajax_callback_data.ajax_nonce
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    modalBody.textContent = 'Ad removed successfully';
    
                    window.location.href = data.data.redirect_url;
                    return;
                } else {
                    modalBody.textContent = 'Failed to remove Ad.';
                    console.error('Failed to remove Ad.');
                }
            })
            .catch(err => {
                modalBody.textContent = 'An error occurred.';
                console.error(err);
            });
        }
    });
    
}
/******************
 * Remove Ad
 * END
******************/

/******************
 * Renew Ad
 * BEGIN
******************/
if( document.querySelector(".job-renewal-btn") ) {
    const renewalAdBtn = document.querySelector(".job-renewal-btn");
    const confirmRenew = document.querySelector('.custom-message-modal-btn.confirm');
    const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');
    const modal = document.querySelector('.custom-message-modal-overlay');

    if (modal) {
        modal.addEventListener('click', function(e) { 
            if (e.target.classList.contains('removed')) {
                modal.classList.remove('d-flex');
                e.target.remove();
            }
        });
    }

    renewalAdBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const renewalPost = renewalAdBtn.getAttribute("data-job");

        confirmRenew.style.display = 'block';
        confirmBtnCancel.style.display = 'block';

        confirmRenew.setAttribute('data-job', renewalPost);
        confirmRenew.setAttribute('data-action', 'renewal');

        const modalMessage = document.querySelector('.custom-message-modal-body p');
        if (modalMessage) {
            modalMessage.textContent = 'The subscription for the job is not active yet, proceed the subscription first.';
        }

        const modalTriggerBtn = document.querySelector('.open-modal-btn');
        if (modalTriggerBtn) {
            modalTriggerBtn.click();
        }
    });

    confirmRenew.addEventListener('click', function() {
        const renewalPost = this.getAttribute('data-job');
        const actionPost = this.getAttribute('data-action');
        if( actionPost != 'renewal' ) {
            return;
        }

        const modalBody = document.querySelector('.custom-message-modal-body p');
        if (modalBody) {
            modalBody.textContent = 'Redirecting to Ad payment. Please wait...';
            confirmRenew.style.display = 'none';
            confirmBtnCancel.style.display = 'none';

            fetch(ajax_callback_data.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'yakkly_employer_job_detail_action',
                    jobId: renewalPost,
                    job_action: actionPost,
                    nonce: ajax_callback_data.ajax_nonce
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    window.location.href = data.data.redirect_url;
                    return;
                } else {
                    modalBody.textContent = 'Failed Ad renewal.';
                    console.error('Failed Ad renewal.');
                }
            })
            .catch(err => {
                modalBody.textContent = 'An error occurred.';
                console.error(err);
            });
        }

    });
}
/******************
 * Renew Ad
 * END
******************/

/******************
 * Payment Ad
 * BEGIN
******************/
if( document.querySelector(".job-payment-btn") ) {
    const paymentAdBtn = document.querySelector(".job-payment-btn");
    const confirmPayment = document.querySelector('.custom-message-modal-btn.confirm');
    const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');
    const modal = document.querySelector('.custom-message-modal-overlay');

    if (modal) {
        modal.addEventListener('click', function(e) { 
            if (e.target.classList.contains('removed')) {
                modal.classList.remove('d-flex');
                e.target.remove();
            }
        });
    }

    paymentAdBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const renewalPost = paymentAdBtn.getAttribute("data-job");

        confirmPayment.style.display = 'block';
        confirmBtnCancel.style.display = 'block';

        confirmPayment.setAttribute('data-job', renewalPost);
        confirmPayment.setAttribute('data-action', 'payment');

        const modalMessage = document.querySelector('.custom-message-modal-body p');
        if (modalMessage) {
            modalMessage.textContent = 'The subscription for the job is not active yet, proceed the subscription first.';
        }

        const modalTriggerBtn = document.querySelector('.open-modal-btn');
        if (modalTriggerBtn) {
            modalTriggerBtn.click();
        }
    });

    confirmPayment.addEventListener('click', function() {
        const renewalPost = this.getAttribute('data-job');
        const actionPost = this.getAttribute('data-action');
        if( actionPost != 'payment' ) {
            return;
        }

        const modalBody = document.querySelector('.custom-message-modal-body p');
        if (modalBody) {
            modalBody.textContent = 'Redirecting to Ad payment. Please wait...';
            confirmPayment.style.display = 'none';
            confirmBtnCancel.style.display = 'none';

            fetch(ajax_callback_data.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'yakkly_employer_job_detail_action',
                    jobId: renewalPost,
                    job_action: actionPost,
                    nonce: ajax_callback_data.ajax_nonce
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    window.location.href = data.data.redirect_url;
                    return;
                } else {
                    modalBody.textContent = 'Failed Ad renewal.';
                    console.error('Failed Ad renewal.');
                }
            })
            .catch(err => {
                modalBody.textContent = 'An error occurred.';
                console.error(err);
            });
        }

    });
}
/******************
 * Payment Ad
 * END
******************/
